module.exports = "/_next/static/images/HeroCCPA@2x-363f26f9363471f399036ce87d98b7ff.png";